import React from 'react';
import ReactWOW from 'react-wow';

import Countdown, { doubleDigit } from 'react-downcount';
import i18n from 'i18next';


const endDate = '';

const clockRenderer = ({ days, hrs, mins, secs, isCompleted }) => {
  return isCompleted
    ? ''
    : <React.Fragment>
      <div className="segment">
        <span className="number">{days}</span>
        <span className="unit">{days > 1 ? 'days': 'day'}</span>
      </div>
      <div className="segment">
        <span className="number">{hrs}</span>
        <span className="unit">{hrs > 1 ? 'hours' : 'hour'}</span>
      </div>
      <div className="segment">
        <span className="number">{doubleDigit(mins)}</span>
        <span className="unit">{mins > 1 ? 'mins' : 'min'}</span>
      </div>
      <div className="segment">
        <span className="number">{doubleDigit(secs)}</span>
        <span className="unit">{secs > 1? 'secs' : 'sec'}</span>
      </div>
    </React.Fragment>
}


class Hero extends React.Component {
  goRegister() {
    // const target = document.getElementById("register");
    // target.scrollIntoView({ block: 'start', behavior: 'smooth' });
    window.location.href ="https://techatshopee.formstack.com/forms/shopee_ultrahackathon_2021"
  }

  render() {
    const msg = this.props.Message;
    return (
      <section id="hero">
        <div className="container">
          <img src="images/ultra_hack_logo.png" alt="Ultra Hackathon logo" className="hero-image" />
          <div className="hero-textContent">
            <ReactWOW animation="fadeInUp" delay="0.1s">
              <h1 className={msg.dateRange  ? "date" : "noDate"}>{
                msg.dateRange 
                  ? (<React.Fragment>{msg.dateRange}< br />{i18n.t(msg.heroDesc)} </React.Fragment>)
                  : (<React.Fragment>{i18n.t(msg.heroDesc)}<br /></React.Fragment>)
              }</h1>
              {/* <Countdown
                className="countdown"
                endDate={endDate}
              >
                {clockRenderer}
              </Countdown> */}
              <p className="start">{msg.heroClockSubtitle}</p>
              <button title={i18n.t(msg.registerNow)} onClick={this.goRegister} className="btn btn-primary">{i18n.t(msg.registerNow)}</button>
              <div className="subtitle">{i18n.t(msg.heroSubtitle)}</div>
            </ReactWOW>
          </div>
          <img src="images/leftArrowOutline.png" alt="arrowGraphic" className="left-arrow-large" />
          <img src="images/leftArrowSolid.png" alt="arrowGraphic" className="left-arrow-small" />
        </div>
        <img src="images/rightArrowSolid.png" alt="arrowGraphic" className="right-arrow-large" />
        <img src="images/rightArrowOutlineWhite.png" alt="arrowGraphic" className="right-arrow-small" />
      </section>
    )
  }
};

export default Hero;
